import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const OTPValidator = ({
  length = 6,
  autoSubmit = true,
  onComplete,
  inputClassName = 'otp-input',
  containerClassName = 'otp-container',
  errorClassName = 'otp-error',
  errorMessage = 'Invalid OTP',
  isValid = true
}) => {
  const [otp, setOtp] = useState(Array(length).fill(''));
  const [activeInput, setActiveInput] = useState(0);

  // Handle change for OTP input
  const handleChange = (e, index) => {
    const value = e.target.value;
    
    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      // Move to next input or submit if last input
      if (index < length - 1) {
        setActiveInput(index + 1);
      } else if (autoSubmit) {
        handleSubmit(newOtp.join(''));
      }
    } else if (value === '') {
      // Handle backspace
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      if (index > 0) {
        setActiveInput(index - 1);
      }
    }
  };

  // Handle key down events
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      setActiveInput(index - 1);
    }
  };

  // Handle paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text/plain').slice(0, length);
    if (/^[0-9]+$/.test(pasteData)) {
      const newOtp = [...otp];
      for (let i = 0; i < pasteData.length; i++) {
        if (i < length) {
          newOtp[i] = pasteData[i];
        }
      }
      setOtp(newOtp);
      if (pasteData.length === length && autoSubmit) {
        handleSubmit(newOtp.join(''));
      }
    }
  };

  // Submit handler
  const handleSubmit = (code) => {
    if (onComplete) {
      onComplete(code);
    }
  };

  // Focus the active input whenever it changes
  useEffect(() => {
    const input = document.getElementById(`otp-input-${activeInput}`);
    if (input) {
      input.focus();
    }
  }, [activeInput]);

  return (
    <div className={containerClassName}>
      <div style={{ display: 'flex', gap: '10px' }}>
        {otp.map((digit, index) => (
          <input
            key={index}
            id={`otp-input-${index}`}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
            className={inputClassName}
            style={{
              width: '40px',
              height: '40px',
              textAlign: 'center',
              fontSize: '18px',
              border: `1px solid ${isValid ? '#ccc' : 'red'}`
            }}
            onFocus={() => setActiveInput(index)}
          />
        ))}
      </div>
      {!isValid && <div className={errorClassName}>{errorMessage}</div>}
    </div>
  );
};

OTPValidator.propTypes = {
  length: PropTypes.number,
  autoSubmit: PropTypes.bool,
  onComplete: PropTypes.func.isRequired,
  inputClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  errorMessage: PropTypes.string,
  isValid: PropTypes.bool
};

export default OTPValidator;